import * as React from "react";

const SvgIcon: React.FC<React.SVGProps<SVGElement>> = ({ width = 11, height = 2 }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 20 3"
    >
        <path stroke="#000" strokeWidth="3" d="M0 1.5h20"></path>
    </svg>
);

export default React.memo(SvgIcon);
